module.exports = __webpack_public_path__ + "img/banner_left.d88ae921.jpg";